import {Shield} from 'modules/events/components/Shield';
import {IDrinkType} from 'modules/events/types';
import {FC} from 'react';

interface IProps {
    drinkType: IDrinkType;
}

// Заготовка на будущее
// По дизайну может быть несколько шильдиков, но api пока отдает только 1
export const ShieldList: FC<IProps> = ({drinkType}) => {
    const {code, title} = drinkType;

    return (
        <div>
            <Shield src={`/images/shields/${code}.svg`} title={title} />
        </div>
    );
};
